import { RoomListItem, RoomType } from '../../models';

export const roomListItemsMock: RoomListItem[] = [
    {
        id: 1,
        name: 'My favourite living room',
        area: '42.5',
        height: '2.5',
        type: RoomType.LivingRoom,
        isCooled: true,
        coolingLoad: '3.2',
        isHeated: true,
        heatingLoad: '4.8'
    },
    {
        id: 2,
        name: 'Main bedroom',
        area: '18.3',
        height: '2.5',
        type: RoomType.Bedroom,
        isCooled: true,
        coolingLoad: '1.8',
        isHeated: true,
        heatingLoad: '2.5'
    },
    {
        id: 3,
        name: 'Bathroom next to bedroom',
        area: '6.2',
        height: '2.5',
        type: RoomType.Bathroom,
        isCooled: false,
        coolingLoad: '',
        isHeated: true,
        heatingLoad: '1.2'
    },
    {
        id: 4,
        name: "Children's room (Philip)",
        area: '12.8',
        height: '2.5',
        type: RoomType.Bedroom,
        isCooled: true,
        coolingLoad: '1.5',
        isHeated: true,
        heatingLoad: '2.1'
    },
    {
        id: 5,
        name: 'Kitchen',
        area: '14.6',
        height: '2.5',
        type: RoomType.Kitchen,
        isCooled: false,
        coolingLoad: '',
        isHeated: true,
        heatingLoad: '1.8'
    },
    {
        id: 6,
        name: 'Storage room',
        area: '4.8',
        height: '2.5',
        type: RoomType.StorageRoom,
        isCooled: false,
        coolingLoad: '',
        isHeated: false,
        heatingLoad: '0'
    },
    {
        id: 8,
        name: 'Toilet for everyone',
        area: '3.2',
        height: '2.5',
        type: RoomType.Bathroom,
        isCooled: false,
        coolingLoad: '',
        isHeated: true,
        heatingLoad: '0.6'
    }
];
